
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowUp = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M23.421 11.765L13.768.8A2.641 2.641 0 0012 0a2.645 2.645 0 00-1.768.8L.579 11.765A1.413 1.413 0 102.7 13.632l7.45-8.466a.25.25 0 01.437.166v17.255a1.413 1.413 0 102.826 0V5.332a.25.25 0 01.438-.165l7.449 8.465a1.413 1.413 0 102.121-1.867z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 23.744a.5.5 0 01-.5-.5V1.575l-10.125 11.5a.503.503 0 01-.705.044.501.501 0 01-.045-.706L10.876.771a1.489 1.489 0 011.06-.501A.336.336 0 0112 .263a.23.23 0 01.043.004c.004-.002.016-.002.028-.002a1.5 1.5 0 011.055.506l10.25 11.643a.501.501 0 01-.751.661L12.5 1.573v21.671a.5.5 0 01-.5.5z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24a.75.75 0 01-.75-.75V2.561l-9.22 9.22a.746.746 0 01-1.06-.001c-.142-.141-.22-.33-.22-.53s.078-.389.22-.53L11.469.22a.74.74 0 01.245-.163l.025-.009a.743.743 0 01.522 0l.021.007c.097.04.179.095.25.166L23.03 10.72c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 01-1.06 0l-9.22-9.22v20.69A.75.75 0 0112 24z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowUp.displayName = 'IconArrowUp';
export default IconArrowUp;